export default {"src":"/_next/static/media/ticket-green-46x46.df913803.svg","height":18,"width":14};